<template>
<v-card>
<v-container fluid>
<v-card>
  <v-spacer></v-spacer>
  </v-card>
  </v-container>
  <v-container fluid>
    <v-card>
     <v-card-title>
       <v-icon x-large>mdi-door-closed-lock</v-icon>Casos Tomados
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="mvm"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
  <template v-slot:item.action="{ item }">
    <v-tooltip bottom>
     <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        class="mr-2"
        v-bind="attrs"
        v-on="on"
        @click="deleteItem(item)"
      >
        mdi-trash-can-outline
      </v-icon>
      </template>
      <span>Eliminar</span>
      </v-tooltip>
    </template>
  </v-data-table>
  </v-card>
  </v-container>
  <v-spacer></v-spacer>
<template>
<div class="text-center">
            <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
            {{this.msj_proceso}}
            </div>
</template>

</v-card>
</template>

<script>
import axios from 'axios'
//import Vue from "vue";
//import JsonExcel from "vue-json-excel";
import XLSX from 'xlsx';
 
//Vue.component("downloadExcel", JsonExcel);

export default {
  data: () => ({
    search: '',
    search2: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    dialog_detail: false,
    valid: true,
    menu: false,
    menu2: false,
    e1: 0,
    btn: false,
    msj_proceso:'',
    progressBar1: false,
    progressBar: false,
    overlay: false,
    step_error1: true,
    step_error2: true,
    step_error3: true,
    step_color1:"primary",
    step_color2:"primary",
    step_color3:"primary",
    TurningStorageArea_Desc:'',
    OpPoint_id: '',
    Supplier_Description:'',
    VendorPurchaseOrder_Num:'',
    Section_Description:'',
    RequestProposal_Dt: '',
    Reception_Dt: '',
    Closing_Dt:'',
    Comment_Txt:'',
    CDay_id:'',
    CHour_Description:'',
    ApiUserType_id: '',
    headers: [
      { text: 'Sesión', value: 'RepSession_id' },
      { text: 'Propuesta Pedido Id', value: 'RequestProposal_id' },
      { text: 'OC', value: 'VendorPurchaseOrder_Num' },
      { text: 'Usuario', value: 'ApiUser_id' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    mvm: [],
    tdetalle_vew: [],
    editedIndex: -1,
    editedItem: {
      RepSession_id: ''
    },
    defaultItem: {
      RepSession_id: ''
    },
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Session' : 'Editar Session'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
       this.progressBar = true
       this.ApiUserType_id = this.$store.state.ApiUserType_id
       this.ApiUserType_id = this.ApiUserType_id.replace(/ /g, "")
       let filter = {}
       if (this.ApiUserType_id == 'R') {
          filter = {};
       } else {
            filter = {};
          //filter = {ApiUser_id: this.$store.state.ApiUser_id};
       }
      
       axios.post(this.api_tool_url + '/get_turncurrselect', filter, this.config)
        .then(response => {
            this.mvm = response.data.ResultRows
            this.progressBar = false
        })
        .catch(error => {
          this.progressBar = false
          alert(error.response.data.message)
        })
    },
    deleteItem (item) {
      const index = this.mvm.indexOf(item)
      confirm('¿Estás seguro/a de que quieres eliminar este bloqueo?') && this.deleteSesion(index)
    },
    deleteSesion(index) {
      this.progressBar = true
      this.msj_proceso = "Limpiando..."
      let usermenus_tmp = this.mvm[index]
      this.editedItem.RepSession_id = usermenus_tmp.RepSession_id
      delete usermenus_tmp.RepSession_id
      axios.post(this.api_tool_url + '/del_reqproposalcurrselect', { RepSession_id: this.editedItem.RepSession_id }, this.config)
        .then(response => {
          this.mvm.splice(index, 1)
          this.progressBar = false
          this.msj_proceso = ''
          this.close()
          })
        .catch(error => {
          this.mvm = []
          this.msj_proceso = error.response.data.message
          })
    },
    close () {
      this.dialog_new = false
    },
    close2 () {
      this.dialog_detail= false
    },

    onexport () { // On Click Excel download button
    
      // export json to Worksheet of Excel
      // only array possible
      const header_r_f = ['Almacen','Punto','OC','Prov','R Social','Seccion','Fecha Emisión','Fecha Entrega','Fecha Cierre','Observación','Fecha de turno','Hora De Turno','Bultos pedidos','Pallets Pedidos','Cantidad de Referencias'];
      const header_r = ['TurningStorageArea_Desc','OpPoint_id','VendorPurchaseOrder_Num','Supplier_id','Supplier_Description','Section_Description','RequestProposal_Dt','Reception_Dt','Closing_Dt','Comment_Txt','CDay_id','CHour_Description','qty_bu','qty_pa','qty_line'];
      var resumenWS = XLSX.utils.json_to_sheet(this.mvm, {header: header_r}) 
    
      const header_d_f = ['Almacen','Punto','OC','Prov','R Social','Seccion','Estado','F Ped','F Ent','F Vto','F Rec','Observacion','Ean','Desc','Med','PCB','Btos x pallet','Bul Ped','Bul Rec','Pallets','Fecha Turno','Hora Turno','Tipo de frío'];
      const header_d = ['TurningStorageArea_Desc','OpPoint_id','VendorPurchaseOrder_Num','Supplier_id','Supplier_Description','Section_Description','RequestProposalStatus_Desc','RequestProposal_Dt','Reception_Dt','Closing_Dt','F_RE','Comment_Txt','ProductBarCode_id','ProductBarCode_Description','MeasureUnit_id','ProductPack_Qty','Layer_Qty','RequestLayer_Qty','REC','RequestPallet_Qty','CDay_id','CHour_Description','ColdType_Desc'];
      var detalleWS = XLSX.utils.json_to_sheet(this.tdetalle, {header: header_d}) 

      var range = XLSX.utils.decode_range(resumenWS['!ref']);
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
        resumenWS[colum].v = header_r_f[C];
      }

      range.e['c'] = header_r_f.length - 1;
      resumenWS['!ref'] = XLSX.utils.encode_range(range);

      var range = XLSX.utils.decode_range(detalleWS['!ref']);
      for(var C = range.s.c; C <= range.e.c; ++C) {
        var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
        detalleWS[colum].v = header_d_f[C];
      }

      range.e['c'] = header_d_f.length - 1;
      detalleWS['!ref'] = XLSX.utils.encode_range(range);

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, resumenWS, 'Resumen') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, detalleWS, 'Detalle')  
      
      var file='Planning_desde_'+this.editedItem.start_dt+'_hasta_'+this.editedItem.end_dt+'.xlsx';

      // export Excel file
      XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TurnCurrSelect.vue